$(function () {
    require("../../../polyfill/polyfill.js");
    var loginMain = require('./login.js');
    var MyDevice = require("../../../cloudflow/PWA/js/Device.js");

    var tagDOMContainingData = $("script[data-origurl]");
    loginMain.loginStart(tagDOMContainingData.attr("data-title"), tagDOMContainingData.attr("data-origurl"), tagDOMContainingData.attr("data-origuser"));

    MyDevice.init();
});